import React, {Component, PropTypes} from 'react'
import { Button, Modal, Form, Input, Radio} from 'antd'
const RadioGroup = Radio.Group
const FormItem = Form.Item
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 }
}

class DescriptionForm extends Component {
  render () {
    const { visible, onCancel, onCreate, form, type} = this.props
    const { getFieldDecorator } = form
    return (
      <Modal
        visible={visible}
        title={'导入人才库'}
        okText="确定"
        onCancel={onCancel}
        onOk={onCreate}
      >
        <Form layout="vertical">
          <FormItem label="是否核心岗位" {...formItemLayout}>
            {
              getFieldDecorator('core', {rules: [{ required: true, message: '请选择是否核心人员'}]})(
                <RadioGroup>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </RadioGroup>
              )
            }
          </FormItem> 
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(DescriptionForm)


// WEBPACK FOOTER //
// ./src/components/recruitment/expandedTableDescipiton.js